// extracted by extract-css-chunks-webpack-plugin
module.exports = {"errorBoundary":"ErrorBoundary__errorBoundary","errorBoundary_button":"ErrorBoundary__errorBoundary_button"};